module.exports = __webpack_public_path__ + "static/media/done-icon.33a95bf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/done-icon.svg
// module id = 883
// module chunks = 21